export const GET_USERS = "GET_USERS";
export const DELETE_USER = "DELETE_USER";
export const GET_SINGLE_USER = "GET_SINGLE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const ADD_USER = "ADD_USER";